import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.span`
    font-size: 0.6em;
`;

const Copyright = ({ ...props }) => <Wrapper {...props}>© {new Date().getFullYear()} Hamilton Manufacturing Corp.</Wrapper>;

export default Copyright;
